import React from 'react';

/**
 * @prop {any} selectedValue
 * @prop {string} label
 * @prop {string} name
 * @prop {array} children (required)
 * @prop {func} selectCallback (required)
 */

const SelectFilter = props => (
  <div className="IndexFilter IndexFilter-button">
    <select
      role="button"
      aria-label={
        props.selectedValue ? `${props.selectedValue}` : 'Default Filter Option'
      }
      name={props.name}
      className="NewButton NewButton--darkNavy"
      value={props.selectedValue || 'default'}
      onChange={e => props.selectCallback(e.target.value)}
    >
      {props.label && (
        <option aria-label={`${props.label}`} value="default" disabled>
          {props.label}
        </option>
      )}
      {props.children}
    </select>
  </div>
);

export default SelectFilter;
